<template>
    <div>
        <h1 class="display-heading">My Payments</h1>

        <div ref="tableSection">
            <div class="d-md-none">
                <div class="card mb-3" v-if="paymentList.length === 0">
                    <div class="card-body">
                        {{isTableLoading ? "Loading Data": "No Data"}}
                    </div>
                </div>

                <div class="card mb-3" v-for="(paymentItem, index) in paymentList" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Payment Date
                            </label>
                            <div>
                                {{paymentItem.paymentCompletedDate}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Description
                            </label>
                            <div>
                                {{paymentItem.description}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Total (RM)
                            </label>
                            <div>
                                {{paymentItem.amount}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Payment Method
                            </label>
                            <div>
                                {{paymentItem.paymentMethod}}
                            </div>
                        </div>
                        <!-- <div>
                            <label class="label-display">
                                Invoice
                            </label>
                            <div class="mt-2">
                                <a class="btn btn-primary btn-primary-insv" v-if="paymentItem.downloadUrl" :href="paymentItem.downloadUrl" target="_blank">Download</a>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive">
                    <table ref="listTable" class="table table-hover">
                        <colgroup>
                            <col width="50">
                            <col width="200">
                            <col>
                            <col width="150">
                            <col width="150">
                            <!-- <col width="180"> -->
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Payment Date</th>
                                <th scope="col">Description</th>
                                <th scope="col" class="text-right">Total (RM)</th>
                                <th scope="col">Payment Method</th>
                                <!-- <th scope="col">Invoice</th> -->
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-show="paymentList.length === 0">
                                <td :colspan="columnsCount" class="text-center font-italic">
                                    {{isTableLoading ? "Loading Data": "No Data"}}
                                </td>
                            </tr>
                            <tr v-for="(paymentItem, index) in paymentList" :key="index">
                                <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                                <td>{{paymentItem.paymentCompletedDate}}</td>
                                <td>
                                    <span :class="'badge badge-pill ' + getTagClass(paymentItem.relationship)">{{paymentItem.relationship}}</span> {{paymentItem.description}}
                                </td>
                                <td class="text-right">{{paymentItem.amount}}</td>
                                <td>{{paymentItem.paymentMethod}}</td>
                                <!-- <td>
                                    <a v-if="paymentItem.downloadUrl" :href="paymentItem.downloadUrl" target="_blank">Download</a>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination';
import {
    convertToUserReadableDate
} from '@/utilities';
import { apiPath } from '@/config';
export default {
    'name': 'MyPayments',
    'components': {
        pagination
    },
    data () {
        return {
            'paymentList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            }
        };
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getPayments();
            });
        }
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPayments();
    },
    'methods': {
        getPayments () {
            this.isTableLoading = true;
            this.axios.get('PaymentList/GetMyPayments',
                {
                    'params': {
                        'page': this.pagination.currentPage,
                        'pageSize': this.pagination.pageSize
                    }
                })
                .then(({
                    data
                }) => {
                    this.isTableLoading = false;
                    let pagedResult = data.data;

                    this.pagination.currentPage = pagedResult.p;
                    this.pagination.totalPages = pagedResult.c;

                    let list = pagedResult.l;
                    this.paymentList = list.map((paymentItem) => ({
                        'amount': paymentItem.am.toFixed(2),
                        'paymentCompletedDate': paymentItem.cd ? convertToUserReadableDate(
                            paymentItem.cd) : '-',
                        'description': this.getPaymentDescription(paymentItem.pt, paymentItem.esid),
                        'relationship': paymentItem.r,
                        'paymentMethod': paymentItem.pm ? paymentItem.pm : '-',
                        'downloadUrl': `${apiPath}Invoice/Get?paymentSummaryId=${paymentItem.psid}`
                    }));
                });
        },
        getPaymentDescription (paymentType, paymentShortId) {
            if (paymentType === 1) {
                if (paymentShortId) {
                    return `Payment for Consultation #${paymentShortId}.`;
                } else {
                    return 'Payment for Consultation.';
                }
            } else if (paymentType === 2) {
                if (paymentShortId) {
                    return `Payment for Prescription #${paymentShortId}.`;
                } else {
                    return 'Payment for Prescription.';
                }
            } else if (paymentType === 4) {
                return 'Payment for Clinic Consultation.';
            } else if (paymentType === 6) {
                return 'Payment for Medicine Cost.';
            } else {
                return 'Payment.';
            }
        },
        getTagClass (tag) {
            switch (tag) {
            case 'Self':
                return 'badge-success';
            case 'Spouse':
                return 'badge-info';
            case 'Dependent':
                return 'badge-secondary';
            default:
                return 'badge-primary';
            }
        }
    }
};

</script>

<style>

</style>
